import React from 'react';

const CompanyRevenueFilterIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 17H3V3H15V7.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M7 17V12H9.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M6.5 6.5H11M6.5 9H10" strokeLinecap="round" strokeWidth="1.5" />
      <path d="M15.1797 10.5V18.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path
        d="M17 11.9546H14.2727C13.9352 11.9546 13.6115 12.0887 13.3728 12.3274C13.1341 12.566 13 12.8898 13 13.2273C13 13.5649 13.1341 13.8886 13.3728 14.1273C13.6115 14.366 13.9352 14.5 14.2727 14.5H16.0909C16.4285 14.5 16.7522 14.6341 16.9909 14.8728C17.2295 15.1115 17.3636 15.4352 17.3636 15.7728C17.3636 16.1103 17.2295 16.434 16.9909 16.6727C16.7522 16.9114 16.4285 17.0455 16.0909 17.0455H13"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default CompanyRevenueFilterIcon;
